<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import CommonLink from '@autobid/ui/components/common/Link.vue'
import { inject } from 'vue'

const props = withDefaults(defineProps<Props>(), {
  asLink: true,
})

const auction = inject<PreparedAuctionItem>('auction')

const link = inject<ComputedRef<string | undefined>>('link')

interface Props {
  asLink?: boolean
}

function onClick(e: Event) {
  if (!props.asLink) {
    return
  }
  e.preventDefault()
}
</script>

<template>
  <CommonLink
    :underline="asLink"
    class="text-left"
    :target="asLink ? '_self' : ''"
    :href="asLink ? link : undefined"
    @click="onClick"
  >
    {{ auction?.title }}
  </CommonLink>
</template>
